import * as React from 'react';
import * as styles from '../Composer.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';

export interface IProps {
  onChange: () => void;
  store?: Store;
  style?: React.CSSProperties;
}

@inject('store')
@observer
export class Teaser extends React.Component<IProps> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const style = this.props.style ?? {};
    return (
      <div
        className={styles.IA_composerElement}
        style={{
          marginTop: 10,
          marginBottom: -20,
          ...style
        }}
      >
        <div className={styles.IA_label}>{this.localizationService.strings.Composer_Teaser} <span style={{ color: this.props.store.highlightColor }}>*</span></div>
        <textarea
          value={this.props.store.teaser.text}
          maxLength={300}
          onChange={(event: any) => {
            if (this.props.store.activeComponent) {
              this.props.store.teaser.text = event.target.value;
              this.props.onChange();
            }
          }}
          onFocus={() => {
            this.props.store.activeComponent = this.props.store.teaser;
          }}
          className={styles.IA_teaser}
          style={{
            border: this.props.store.activeComponent && this.props.store.activeComponent.type === "teaser" ? (!this.props.store.validateTeaser() ? "2px solid red" : `2px solid ${this.props.store.highlightColor}`) : (!this.props.store.validateTeaser() ? "1px solid red" : "1px solid rgb(203, 203, 203)"),
            marginBottom: this.props.store.activeComponent && this.props.store.activeComponent.type === "teaser" ? 0 : 2,
            borderRadius: 5,
            fontFamily: this.props.store.fontSlots?.body?.fontFamily
            
          }}
        />
        <div className={styles.IA_teaserCountdown}>{`${300 - (this.props.store.teaser?.text?.length ?? 0)} ${this.localizationService.strings.Composer_TeaserCharactersLeft?.toLowerCase()}`}</div>
        {!this.props.store.validateTeaser() &&
          <div
            className={styles.IA_composer_error_message}
            style={{
              clear: "both",
              float: "left",
              marginBottom: 20,
              marginTop: 0
            }}
          >
            {this.localizationService.strings.Composer_ValidateTeaser}
          </div>
        }
      </div>
    );
  }
}